import { fetcher } from "@certn/api";
import { showToast, toastQueue } from "@certn/cascadia";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function useVerifyWebhook(webhookId: string, onVerified: () => void) {
  const [isVerifying, setIsVerifying] = useState(false);
  const { t } = useTranslation();

  const verify = async () => {
    setIsVerifying(true);
    const loadingToast = showToast(t("Verifying webhook..."), { type: "info" });
    try {
      await fetcher.submit(
        `/api/internal/client-portal/public-api/webhooks/${webhookId}/verify/`
      );
      toastQueue.close(loadingToast);
      showToast(t("Webhook verified"), { type: "success" });
      onVerified();
    } catch (e) {
      console.error("Failed to verify webhook", e);
      toastQueue.close(loadingToast);
      showToast(t("Failed to verify webhook"), {
        type: "error",
      });
    }
    setIsVerifying(false);
  };
  return { isVerifying, verify };
}
